import { useState } from 'react';
import { ArrowRight, Mail, User, Lock } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';

export const LeadCapture = ({ data, onUpdate, onNext }) => {
  const [errors, setErrors] = useState({});
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    
    if (!data.fullName?.trim()) {
      newErrors.fullName = 'Please enter your name';
    }
    
    if (!data.email?.trim()) {
      newErrors.email = 'Please enter your email address';
    } else if (!validateEmail(data.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    setErrors(newErrors);
    
    if (Object.keys(newErrors).length === 0) {
      onNext();
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="bonza-form-section" data-testid="lead-capture-form">
      <div className="bonza-step-header">
        <h2>Let's get started</h2>
        <p>We'll email your result so you can refer back to it later.</p>
      </div>
      
      <div className="space-y-5">
        <div className="space-y-2">
          <Label htmlFor="fullName" className="text-[#1A1523] font-medium">
            Full Name
          </Label>
          <div className="relative">
            <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#64748B]" />
            <Input
              id="fullName"
              data-testid="input-fullName"
              type="text"
              placeholder="John Smith"
              value={data.fullName || ''}
              onChange={(e) => onUpdate({ fullName: e.target.value })}
              className={`bonza-input h-14 pl-12 text-base ${errors.fullName ? 'border-red-500' : ''}`}
            />
          </div>
          {errors.fullName && (
            <p className="text-red-500 text-sm" data-testid="error-fullName">{errors.fullName}</p>
          )}
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="email" className="text-[#1A1523] font-medium">
            Email Address
          </Label>
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#64748B]" />
            <Input
              id="email"
              data-testid="input-email"
              type="email"
              placeholder="john@example.com"
              value={data.email || ''}
              onChange={(e) => onUpdate({ email: e.target.value })}
              className={`bonza-input h-14 pl-12 text-base ${errors.email ? 'border-red-500' : ''}`}
            />
          </div>
          {errors.email && (
            <p className="text-red-500 text-sm" data-testid="error-email">{errors.email}</p>
          )}
        </div>
      </div>
      
      <div className="mt-6 flex items-center gap-2 text-sm text-[#64748B]">
        <Lock className="w-4 h-4" />
        <span>We respect your privacy. No spam. No pressure.</span>
      </div>
      
      <Button
        type="submit"
        data-testid="continue-btn"
        className="bonza-btn-primary w-full h-14 mt-8 text-base font-semibold rounded-xl"
      >
        Continue
        <ArrowRight className="w-5 h-5 ml-2" />
      </Button>
    </form>
  );
};
